export const CANCEL_URL = "/visi/everywhere/chat/cancel";
export const HISTORY_URL = "/visi/everywhere/chat/history";
export const CONVERSATIONS_URL = "/visi/everywhere/conversations";
export const PAGES_URL = "/visi/everywhere/pages";

export const ALL_PAGES_SCOPE = "all";
